export default {"src":"/_next/static/media/my-table-icon.d42bdd86.svg","height":16,"width":16};